import React from "react";
import styles from './BenefitCard.module.css';
import beneficio_1 from '../../img/beneficio_1.png'
import beneficio_2 from '../../img/beneficio_2.png'
import beneficio_3 from '../../img/beneficio_3.png'
import beneficio_4 from '../../img/beneficio_4.png'
import beneficio_5 from '../../img/beneficio_5.jpg'

const BenefitCard = ({ titulo, descripcion, linkTermCond, id }) => {
    
    const obtenerImagen = (codigo) => {
        let imagen = ''

        if (codigo === '1') {
            imagen = beneficio_1
        } else if (codigo === '2') {
            imagen = beneficio_2
        } else if (codigo === '3') {
            imagen = beneficio_3
        } else if (codigo === '4') {
            imagen = beneficio_4
        } else if (codigo === '5') {
            imagen = beneficio_5
        } 

        return imagen
    }

    return (
        <React.Fragment>
            <div className={styles.benefitCard}>
                <div className={styles.benefitCard__image}>
                    <img src={obtenerImagen(id)} alt="" />
                </div>
                <div className={styles.benefitCard__content}>
                    <h3>{titulo}</h3> 
                    <p>{descripcion}</p> 
                    {linkTermCond &&
                        <a href={linkTermCond} target="_blank" rel="noopener noreferrer">Términos y condiciones</a> 
                    }
                    
                </div>
            </div>
        </React.Fragment>
    );
}

export default BenefitCard;